import {
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { CustomTextField } from "../../Components/CustomTextField";

import { DatePickerInput } from "@mantine/dates";

export const EdificationForm = ({ formValues, handleChange }) => {
  const { t } = useTranslation("main");
  const [showMore, setShowMore] = useState(false);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <CustomTextField
        field="address"
        value={formValues.address}
        onChange={handleChange}
      />
      <CustomTextField
        field="owner"
        value={formValues.owner}
        options={["Privado", "Público", "Municipal"]}
        onChange={handleChange}
      />
      <CustomTextField
        field="current_use"
        value={formValues.current_use}
        options={[
          "Industrial",
          "Residencial",
          "Oficinas",
          "Agrícola",
          "Retai",
          "Servicios Públicos",
          "Otros",
        ]}
        onChange={handleChange}
      />

      <a
        href={formValues.link_maps}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "block",
          color: "blue",
          textDecoration: "underline",
          fontSize: "1rem",
        }}
      >
        {t("link_maps")}
      </a>
      <a
        href={formValues.link_catastro}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "block",
          color: "blue",
          textDecoration: "underline",
          fontSize: "1rem",
        }}
      >
        {t("link_catastro")}
      </a>

      <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
        <Typography
          style={{ cursor: "pointer" }}
          onClick={() => setShowMore((prev) => !prev)}
        >
          {showMore ? `- ${t("less")}` : `+ ${t("more")}`}
        </Typography>
        <Divider style={{ flexGrow: "1" }} />
      </div>
      <div
        style={{
          maxHeight: showMore ? "500px" : "0px",
          // height: showMore ? "100px" : "0px",
          overflow: "hidden",
          transition: "max-height 0.5s ease-in-out",
          // backgroundColor: "lightgrey",
          margin: "1rem",
          marginTop: "calc(1rem - 8px)",
        }}
      >
        <div
          style={{
            marginTop: "8px",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <CustomTextField
            field="n_ref_catastral"
            value={formValues.n_ref_catastral}
            onChange={handleChange}
          />
          <CustomTextField
            field="province"
            value={formValues.province}
            onChange={handleChange}
          />
          <CustomTextField
            field="municipality"
            value={formValues.municipality}
            onChange={handleChange}
          />
          <CustomTextField
            field="ine_code"
            value={formValues.ine_code}
            onChange={handleChange}
            type="number"
          />
          <CustomTextField
            field="building_age"
            value={formValues.building_age}
            onChange={handleChange}
            type="number"
          />
          <DatePickerInput
            clearable
            valueFormat="YYYY-MM-DD"
            label={t("building_creation_date")}
            placeholder={t("building_creation_date")}
            value={
              formValues.building_creation_date
                ? new Date(formValues.building_creation_date?.replace(/Z$/, ""))
                : null // Elimina la 'Z' si está al final
            }
            onChange={handleChange("building_creation_date")}
            localization="es"
          />
          <CustomTextField
            field="fx_modification"
            label={t("fx_modification")}
            value={formValues.fx_modification}
            readOnly
          />
          <CustomTextField
            field="made_by"
            value={formValues.made_by}
            readOnly
          />
        </div>
      </div>
    </div>
  );
};
